// extracted by mini-css-extract-plugin
export default {"cross-sectoral-standard-tag":"CrossSectoralStandards_cross-sectoral-standard-tag__DIDdx"};